import React, { useState } from 'react'
import SwiperThumb from '../../pages/Bookings/components/SwiperThumb';
import noImg from "../../assets/images/image_placeholder.jpg";
import moment from "moment";
import { FaHotel } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import { MdEmail, MdPhone } from 'react-icons/md';
import './login.css'

export default function HotelInfo({hotelPolicyData,branchDataRes},props) {


    const [activeTab, setActiveTab] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

  const tabsData = [
    { label: "Hotel Photos", content: "Hotel Photos" },
    { label: "Hotel Details", content: "Hotel Details" },
    { label: "Hotel Map", content: "Hotel Map" },
    // { label: "Enquiry", content: "Enquiry" }
  ];

  const handleTabClick = (index) => {
    if (index !== activeTab) {
      setIsAnimating(true);
      setTimeout(() => {
        setActiveTab(index);
        setIsAnimating(false);
      }, 300); // Duration of the animation in ms
    }
  };


const attachmentUrls = hotelPolicyData?.data?.[0]?.property?.gallery?.map(item => item.attachment);



  return (
    <div>


       <div>
            <div className="tabs-container">
              <div className="tabs-header">
                {tabsData.map((tab, index) => (
                  <button
                    key={index}
                    className={`tab-button ${activeTab === index ? "active" : ""}`}
                    onClick={() => handleTabClick(index)}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              <div
                className={`tabs-content ${isAnimating ? "fade-out" : "fade-in"}`}
                key={activeTab}
              >
                {tabsData[activeTab] && (() => {
                  const activeLabel = tabsData[activeTab].label;

                  if (activeLabel === "Hotel Details") {
                    return (
                      <div>
                        <div className="resort-card mb-4  bg-white">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <h5 className="resort-title mb-1">
                                <a
                                  // href={`https://${appStartData?.menu?.Home}`}
                                  rel="noreferrer"
                                  target="_blank"
                                  className="text-decoration-none text-primary fw-semibold"
                                >
                                  <FaHotel />
                                  &nbsp;
                                  {branchDataRes?.property?.emailalias}
                                </a>
                              </h5>
                            </div>
                          </div>

                          <p className="resort-address text-muted mb-2">
                          <b style={{color:"#212529"}}>Address</b>:
                            &nbsp;
                            {branchDataRes?.property?.address}&nbsp;
                            {branchDataRes?.property?.country}&nbsp;
                            {branchDataRes?.property?.pincode}
                          </p>

                          <div className="resort-contact d-flex flex-wrap align-items-center gap-3">
                            <div className="d-flex align-items-center">
                            <b>Phone</b>
                              &nbsp;
                              <span className="text-dark">
                               : {branchDataRes?.property?.mobile1}
                              </span>
                            </div>
                            <div className="d-flex align-items-center">
                            <b>Email</b>
                              &nbsp;
                              <span className="text-dark">
                                : {branchDataRes?.property?.from}
                              </span>
                            </div>
                            <div className="d-flex align-items-center">
                             <b>Hotel Type</b>
                              &nbsp;
                              <span className="text-dark">
                                : Resort
                              </span>
                            </div>
                          </div>
                        </div>

                        <a
                          rel="noreferrer"
                          href="https://www.flipsnack.com/AD8B785569B/online-guest-guidebook/full-view.html"
                          target="_blank"
                          className="vres_btn mb-3"
                        >
                          <i className="fa fa-download"></i> Your Guidebook for Fun!
                        </a>
                      <hr className="mt-4 mb-0" />
                        <p
                        className="mt-4"
                          dangerouslySetInnerHTML={{
                            __html:
                              hotelPolicyData?.data?.[0]?.property
                                ?.doctemplate || "No details available.",
                          }}
                        ></p>
                      </div>
                    );
                  } else if (activeLabel === "Enquiry") {
                    return (
                      <div className="enquiry-container">
                        <h6>Enquiry</h6>
                        <form>
                          <div>
                            <label htmlFor="name">Name:</label>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              placeholder="Enter your name"
                            />
                          </div>
                          <div>
                            <label htmlFor="email">Email:</label>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Enter your email"
                            />
                          </div>
                          <div>
                            <label htmlFor="message">Message:</label>
                            <textarea
                              id="message"
                              name="message"
                              placeholder="Write your message here"
                            ></textarea>
                          </div>
                          <button type="submit">Submit</button>
                        </form>
                      </div>
                    );
                  } else if (activeLabel === "Hotel Map") {
                    return (
                      <div>
                        <div style={{ width: "100%", height: "450px" }}>
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3072.988929658085!2d-106.05352492432158!3d39.62745310329952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876a5b992a739c1b%3A0x23070399c7fc8d6e!2sSpinnaker%20Lake%20Dillon!5e0!3m2!1sen!2sin!4v1746130491184!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Spinnaker Lake Dillon Map"
                          ></iframe>
                        </div>
                      </div>
                    );
                  } else if (activeLabel === "Hotel Photos") {
                    return (
                      <div>
                        {hotelPolicyData?.data?.[0]?.property?.gallery?.length > 0 ? (
                          <SwiperThumb
                            objectFit={true}
                            height={400}
                            value={7}
                            roomImgs={attachmentUrls}
                          />
                        ) : (
                          <div className="carousel_img_container">
                            <img
                              style={{ width: "100%", height: "100%" }}
                              alt="carouselImg"
                              loading="lazy"
                              src={noImg}
                            />
                          </div>
                        )}
                      </div>
                    );
                  } else {
                    return (
                      <div>
                        <p>No content available for this tab.</p>
                      </div>
                    );
                  }
                })()}
              </div>
            </div>
          </div>
    </div>
  )
}
